<template>
    <div>
        Item code: <input type="text" v-model="itemCode" />&nbsp;<b-button class="cerca" @click="cerca()" >Search</b-button><br /><br />
        <ShowComponents :m="null" :main="true" :search="search" v-if="search" />
    </div>
</template>

<script>
import ShowComponents from "@/components/ShowComponents.vue";
export default {
	name: "BillOfMaterials",
	components: {
        ShowComponents
	},
	data() {
		return {
            itemCode: "",
            search: null,
		};
	},
	async mounted() {
	},
	computed: {
	},
	methods: {
        cerca() {
            console.log("cerca", this.itemCode);    
            this.search = this.itemCode;
        }
	},
};
</script>

<style scoped>
</style>
<style>
</style>
